<template>
  <section class="py-0">
    <div class="container">
      <!-- Breadcrumb -->
      <layout-breadcrumb :breadcrumbs="breadcrumbs"></layout-breadcrumb>

      <!-- Header -->
      <div class="row justify-content-center text-center mb-7">
        <div class="col-lg-8">
          <h2 class="display-5 font-weight-bold">Actividades</h2>
          <p class="lead">Conoce todas nuestras actividades de voluntariado</p>
        </div>
      </div>

      <!-- Grid de Actividades -->
      <div class="row">
        <template v-for="(actividad, index) in actividades">
          <div class="col-lg-4 col-md-6 mb-4" :key="actividad.voluntariadoActividadId">
            <div class="card card-frame card-owework border hover-shadow-9 transition-hover">
              <div class="card-img-top w-100 text-center">
                <a :href="'/voluntariado/detalle/' + actividad.voluntariadoActividadId">
                  <img class="img-fluid w-100 rounded cimage-slider" :src="`${filesUrl}${actividad.rutaImagenMiniatura}`" :alt="actividad.titulo" />
                </a>
              </div>
              <div class="card-body p-2">
                <div class="d-flex justify-content-center text-center" style="height:6.6rem !important;overflow:hidden">
                  <a :href="'/voluntariado/detalle/' + actividad.voluntariadoActividadId">
                    <h6 class="card-title fs-15 text-transparencia">{{ actividad.titulo }}</h6>
                  </a>
                </div>
              </div>
              <div class="card-footer text-right pt-0">
                <a class="fs-13 fw-600 anim-link-2 anim-link-2-primary" :href="'/voluntariado/detalle/' + actividad.voluntariadoActividadId">Leer más<i class="fa fa-search-plus ml-1"></i></a>
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- Mensaje si no hay actividades -->
      <div v-if="actividades.length === 0" class="text-center py-5">
        <p class="text-muted">No hay actividades disponibles en este momento.</p>
      </div>
    </div>
  </section>
</template>

<script>
import layoutBreadcrumb from "@/layout/layout-breadcrumb";

export default {
  name: "actividades-listar",
  metaInfo: {
    title: "Actividades",
  },
  components: {
    layoutBreadcrumb,
  },
  data: () => ({
    actividades: [],
    breadcrumbs: [],
  }),
  methods: {
    fetchActividades: function() {
      this.$http.get(this.apiRoute("Common", "ListVoluntariadoActividadesAll")).then(function(response) {
        if (!response.body.error) {
          this.actividades = response.body.data;
        }
      });
    },
  },
  mounted: function() {
    this.fetchActividades();

    this.breadcrumbs = [
      { name: "Inicio", url: "/home", icon: "fa fa-home", active: false },
      { name: "Voluntariado", url: "/voluntariado", icon: "", active: false },
      { name: "Actividades", url: "/voluntariado/actividades", icon: "", active: false },
      { name: "Listar", url: "", icon: "", active: true },
    ];
  },
};
</script>

<style scoped>
.card-frame {
  height: 100%;
}

.card-img-top img {
  object-fit: contain;
  height: 200px;
}
</style>
